export default __webpack_public_path__ + "static/goldpartner-6d13e6d14cc0074f319479e2cf48fb65.png";